export default __webpack_public_path__ + "static/03-e4223b8c16ed1068da2986dbf860cbcc.png";